<script setup lang="ts">
defineProps<{
  isLoading: boolean;
  error: string | null;
}>();

const emit = defineEmits<{
  submit: [email: string];
  cancel: [];
}>();

const email = ref('');
const form = ref<{ validate: () => Promise<{ valid: boolean }> } | null>(null);

const emailRules = [
  (v: string) => !!v || 'Email is required',
  (v: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Must be a valid email address',
];

async function handleSubmit() {
  const result = await form.value?.validate();
  if (!result?.valid) return;
  emit('submit', email.value);
}

function reset() {
  email.value = '';
}

defineExpose({ reset });
</script>

<template>
  <v-form
    ref="form"
    class="invite-attendee-form"
    @submit.prevent="handleSubmit"
  >
    <v-text-field
      v-model="email"
      label="Email address"
      type="email"
      :rules="emailRules"
      :error-messages="error ? [error] : []"
      :disabled="isLoading"
      density="compact"
      hide-details="auto"
      class="mb-2"
      @keyup.enter="handleSubmit"
    />
    <div class="d-flex ga-2">
      <v-btn
        color="primary"
        size="small"
        :loading="isLoading"
        :disabled="!email"
        @click="handleSubmit"
      >
        Send invite
      </v-btn>
      <v-btn
        variant="text"
        size="small"
        :disabled="isLoading"
        @click="emit('cancel')"
      >
        Cancel
      </v-btn>
    </div>
  </v-form>
</template>
